import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';

const BrandForm = React.lazy(() => import('components/Brand/Form/Form'));

function ScreensBrandsForm(params: Readonly<RoutePrivateProps>) {
  return (
    <BaseLayout className="background-blue">
      <DocumentTitle>{params.id ? 'Edit' : 'Create'} Brand</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <BrandForm id={params.id ? Number(params.id) : null} />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensBrandsForm;
